import {
  FormControlLabel,
  Modal,
  Paper,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Typography,
  withStyles
} from '@material-ui/core';
import moment from 'moment';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ReactSelectMaterialUi from 'react-select-material-ui';
import { compose, lifecycle } from 'recompose';
import withHandlers from 'recompose/withHandlers';
import withState from 'recompose/withState';
import { bindActionCreators } from 'redux';
import { sendLogin } from '../../auth/Auth';
import CancelButton from '../../components/atoms/CancelButton';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import RequiredButton from '../../components/atoms/RequiredButton';
import ValidationText from '../../components/atoms/ValidationText';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import {
  getListMenuShashokuData,
  getListShashokuUserData,
  getListShopShashokuData
} from '../../libs/apis/SystemApi';
import { postTicketsUsedByAdminData } from '../../libs/apis/TicketApi';
import ShashokuTicketUsedByAdminAddConfirm from './ShashokuTicketUsedByAdminAddConfirm';
import usageTypes from '../../constants/UsageType';
import taxRatePercent from '../../constants/taxRate';

const styles = theme => ({
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      padding: 16
    }
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      marginBottom: 10
    }
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 5px'
    },
    display: 'flex',
    flexDirection: 'column'
  },
  alignEnd: {
    alignSelf: 'end'
  },
  editTable: {
    width: 'auto',
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    },
    '& tr': {
      [theme.breakpoints.down('sm')]: {
        display: 'block'
      }
    }
  },
  tableCellBorderNone: {
    borderBottom: 'none',
    [theme.breakpoints.down('sm')]: {
      borderBottom: 'none',
      display: 'block',
      border: 0
    }
  },
  textField100: {
    padding: '0px 5px 0px 5px',
    width: '100px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  textFieldLong: {
    padding: '0px 5px 0px 5px',
    width: '500px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  button: {
    margin: '5px auto'
  },
  priceCalc: {
    margin: '0px 5px',
    color: '#aaa'
  },
  colLeft: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingBottom: 5
    }
  },
  colRight: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingTop: 0
    }
  },
  hideMobile: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  width100: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      display: 'block',
      padding: 0
    }
  }
});

const enhance = compose(
  connect(
    state => ({
      systems: state.systems.list
    }),
    dispatch => ({
      actions: bindActionCreators({}, dispatch)
    })
  ),
  withState('openAddProgress', 'updateOpenAddProgress', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('loading', 'updateLoading', false),
  withState('connectSystem', 'setConnectSystem', ''),
  withState('connectSystemName', 'setConnectSystemName', ''),
  withState('openAddConfirm', 'setOpenAddConfirm', false),
  withState('connectSystemError', 'setConnectSystemError', ''),
  withState('user', 'setUser', ''),
  withState('username', 'setUsername'),
  withState('userError', 'setUserError', ''),
  withState('userOptions', 'setUserOptions', []),
  withState('shopOptions', 'setShopOptions', []),
  withState('ticketId', 'setTicketId', ''),
  withState('ticketName', 'setTicketName', ''),
  withState('ticketIdError', 'setTicketIdError', ''),
  withState('shopId', 'setShopId', ''),
  withState('shopName', 'setShopName', ''),
  withState('shopIdError', 'setShopIdError', ''),
  withState('shopOptions', 'setShopOptions', []),
  withState('menuId', 'setMenuId', ''),
  withState('menuName', 'setMenuName', ''),
  withState('menuIdError', 'setMenuIdError', ''),
  withState('menuOptions', 'setMenuOptions', []),
  withState('usedAt', 'setUsedAt', ''),
  withState('openAddConfirm', 'updateOpenAddConfirm', false),
  withState('usedAtError', 'setUsedAtError', ''),
  withState('allowMenuPrice', 'setAllowMenuPrice', false),
  withState('menuPrice', 'setMenuPrice', 0),
  withState('menuPriceError', 'setMenuPriceError', ''),
  withState('usedTicketNum', 'setUsedTicketNum', 1),
  withState('usedTicketNumError', 'setUsedTicketNumError', ''),
  withState('usageType', 'setUsageType', null),
  withState('taxRate', 'setTaxRate', taxRatePercent.TAX_RATE_10_PERCENT),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      console.log();
    }
  })
);

const Main = enhance(
  ({
    allowMenuPrice,
    setAllowMenuPrice,
    history,
    loading,
    updateLoading,
    openAddProgress,
    updateOpenAddProgress,
    openAddConfirm,
    updateOpenAddConfirm,
    systems,
    connectSystemError,
    setConnectSystemError,
    connectSystem,
    setConnectSystem,
    connectSystemName,
    setConnectSystemName,
    user,
    username,
    setUsername,
    userError,
    setUserError,
    userOptions,
    setUserOptions,
    setUser,
    ticketId,
    ticketName,
    setTicketName,
    setTicketId,
    ticketIdError,
    setTicketIdError,
    shopId,
    setShopId,
    shopName,
    setShopName,
    shopOptions,
    setShopOptions,
    shopIdError,
    setShopIdError,
    menuId,
    setMenuId,
    menuName,
    setMenuName,
    menuIdError,
    menuOptions,
    setMenuOptions,
    setMenuIdError,
    usedAt,
    setUsedAt,
    usedAtError,
    setUsedAtError,
    classes,
    setOpenAdd,
    resultMessage,
    setResultMessage,
    menuPrice,
    setMenuPrice,
    menuPriceError,
    setMenuPriceError,
    usedTicketNum,
    setUsedTicketNum,
    usedTicketNumError,
    setUsedTicketNumError,
    onSuccess,
    taxRate,
    setTaxRate,
    usageType,
    setUsageType
  }) => {
    const USAGE_TYPE_MENU = usageTypes[0].id;
    const USAGE_TYPE_VOUCHER = usageTypes[1].id;

    const errors = {
      connectSystemError,
      userError,
      ticketIdError,
      shopIdError,
      menuIdError,
      usedAtError,
      menuPriceError,
      usedTicketNumError
    };

    const selectedUser = userOptions.find(item => item.value === user);
    const selectedUserId = (selectedUser && selectedUser.id) || null;
    const selectedEmployeeNo =
      (selectedUser && selectedUser.employeeNo) || null;
    const selectedUserEmail = (selectedUser && selectedUser.email) || null;

    const submitData = {
      fromSystemId: connectSystem,
      userId: selectedUserId,
      employeeNo: selectedEmployeeNo,
      displayName: username,
      userEmail: selectedUserEmail,
      ticketId,
      shopId,
      menuId: menuId === 'price' ? null : menuId,
      menuPrice: menuId === 'price' ? menuPrice : null,
      usedAt,
      usedTicketNum,
      usedTaxRate: taxRate
    };

    const ticketOptions = [
      {
        label: 'A 社食チケット（上限金額指定）',
        value: 1
      },
      {
        label: 'B 社食チケット（金額×枚数指定）',
        value: 5
      },
      {
        label: 'D 特別手当チケット（メニュー×期限指定）',
        value: 2
      },
      {
        label: 'E 褒賞チケット (上限金額指定ｘ期限指定) ',
        value: 7
      },
      {
        label: 'F 社内交流チケット（金額×枚数×期限指定）',
        value: 4
      }
    ];

    const validConnectSystem = () => {
      const value = connectSystem;
      if (!value) {
        setConnectSystemError('必須項目です。');
        return 1;
      }
      setConnectSystemError('');
      return 0;
    };

    const validUser = () => {
      const value = user;
      if (!value) {
        setUserError('必須項目です。');
        return 1;
      }
      setUserError('');
      return 0;
    };

    const validTicketId = () => {
      const value = ticketId;
      if (!value) {
        setTicketIdError('必須項目です。');
        return 1;
      }
      setTicketIdError('');
      return 0;
    };

    const validShopId = () => {
      const value = shopId;
      if (!value) {
        setShopIdError('必須項目です。');
        return 1;
      }
      setShopIdError('');
      return 0;
    };

    const validateUsedAt = () => {
      const value = usedAt;
      if (!value) {
        setUsedAtError('必須項目です。');
        return 1;
      }
      setUsedAtError('');
      return 0;
    };

    const validMenuId = () => {
      const value = menuId;
      if (!value) {
        setMenuIdError('必須項目です。');
        return 1;
      }
      setMenuIdError('');
      return 0;
    };

    function validateMenuPrice() {
      if (Number(menuPrice <= 0)) {
        setMenuPriceError('正しくご入力ください。');
        return 1;
      }
      setMenuPriceError('');
      return 0;
    }

    function validateUsedTicketNum() {
      if (Number(usedTicketNum <= 0)) {
        setUsedTicketNumError('正しくご入力ください。');
        return 1;
      }
      setUsedTicketNumError('');
      return 0;
    }

    function valid() {
      let errorCount =
        validConnectSystem() +
        validUser() +
        validTicketId() +
        validShopId() +
        validateUsedTicketNum() +
        validateUsedAt();
      if (menuId === 'price') errorCount += validateMenuPrice();
      return errorCount === 0;
    }

    function confirmAction() {
      if (!valid()) {
        alert('登録情報を正しく入力してください。');
      } else {
        updateOpenAddConfirm(true);
      }
    }

    function cancelAction() {
      setOpenAdd(false);
    }

    const getConnectSystemOptions = () => {
      return systems.map(item => ({
        label: item.connectSystemName,
        value: item.connectSystemId
      }));
    };

    async function getUserOptions(page, totalCount) {
      updateOpenAddProgress(true);
      updateLoading(true);
      const fullfilled =
        (totalCount && !!(page * 500 > totalCount)) || totalCount === 0;
      if (!connectSystem) {
        setUserOptions([]);
      } else if (!fullfilled) {
        const params = {
          systemId: connectSystem,
          page,
          limit: 500
        };
        try {
          const response = await getListShashokuUserData(params);
          const newData = response.data.list.map(item => ({
            employeeNo: item.employeeNo,
            displayName: item.displayName,
            label: item.employeeNo
              ? `${item.employeeNo} - ${item.displayName}`
              : item.displayName,
            value: item.userId,
            id: item.userId,
            email: item.email
          }));
          setUserOptions(old => (page === 0 ? newData : [...old, ...newData]));
          await getUserOptions(page + 1, response.data.count);
        } catch (e) {
          if (e.response && e.response.status) {
            sendLogin({ history });
          }
          console.log(e);
        }
      }
      if (page === 0) {
        updateOpenAddProgress(false);
        updateLoading(false);
      }
    }

    async function getShopOptions(page, totalCount) {
      if (!connectSystem) {
        setShopOptions([]);
        setShopId('');
        setShopName('');
        setMenuName('');
        setMenuId('');
        setUser('');
        setUsername('');
        return;
      }
      const fullfilled =
        (totalCount && !!(page * 500 > totalCount)) || totalCount === 0;
      if (fullfilled) return;
      const params = {
        fromSystemId: connectSystem,
        shashokuFlag: 1,
        allMenuEnable: 1,
        page: page + 1,
        limit: 500
      };
      try {
        const response = await getListShopShashokuData(params);
        const newData = response.data.list.map(item => ({
          label: item.shopName,
          value: item.shopId
        }));
        setShopOptions(old => (page === 0 ? newData : [...old, ...newData]));
        await getShopOptions(page + 1, response.data.count);
      } catch (e) {
        if (e.response && e.response.status) {
          sendLogin({ history });
        }
        console.log(e);
      }
    }

    async function getMenuOptions() {
      if (!connectSystem || !shopId) {
        setMenuOptions([]);
        setMenuName('');
        setMenuId('');
        return;
      }
      const params = {
        fromSystemId: connectSystem,
        shashokuFlag: 1,
        allMenuEnable: 1
      };
      try {
        const response = await getListMenuShashokuData(shopId, params);
        setMenuOptions(
          response.data.menus.map(item => ({
            label: item.menuName,
            value: item.menuId,
            usageType: item.usageType,
            taxType: item.taxType,
            reducedTaxType: item.reducedTaxType
          }))
        );
        setAllowMenuPrice(response.data.adminShashokuAllowMenuPrice === 1);
      } catch (e) {
        if (e.response && e.response.status) {
          sendLogin({ history });
        }
        console.log(e);
      }
    }

    useEffect(() => {
      getUserOptions(0);
      getShopOptions(0);
    }, [connectSystem]);

    useEffect(() => {
      getMenuOptions();
    }, [connectSystem, shopId]);

    async function onSubmitAdd() {
      updateOpenAddProgress(true);
      updateLoading(true);
      try {
        await postTicketsUsedByAdminData(submitData);
        setResultMessage('データの追加が完了しました。');
      } catch (e) {
        console.log(e);
        setResultMessage('データの追加に失敗しました。再度ご確認ください。');
      } finally {
        updateLoading(false);
      }
    }

    console.log('menuId', menuId);

    return (
      <div className={classes.root}>
        <div className={classes.pageTitle}>
          <Typography variant="h6">使用済データ登録</Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <Table className={classes.editTable}>
            <TableBody>
              <TableRow>
                <TableCell>
                  <RequiredButton />
                </TableCell>
                <TableCell>
                  <ReactSelectMaterialUi
                    required
                    value={connectSystem}
                    label="システム名"
                    className={classes.textField}
                    options={getConnectSystemOptions()}
                    margin="normal"
                    onChange={(e, o) => {
                      setShopId('');
                      setShopName('');
                      setUser('');
                      setUsername('');
                      setMenuName('');
                      setMenuId('');
                      if (e) {
                        setConnectSystem(Number(e));
                        setConnectSystemName(o.label);
                      } else {
                        setConnectSystem('');
                        setConnectSystemName('');
                      }
                    }}
                    SelectProps={{
                      isClearable: true,
                      msgNoOptionsMatchFilter: 'No options'
                    }}
                    onBlur={validConnectSystem}
                  />
                  <ValidationText message={errors.connectSystemError} />
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>
                  <RequiredButton />
                </TableCell>
                <TableCell>
                  <ReactSelectMaterialUi
                    key={`username-${connectSystem}`}
                    required
                    label="ユーザー名"
                    className={classes.textField}
                    options={userOptions}
                    margin="normal"
                    value={user}
                    onChange={(e, o) => {
                      if (e) {
                        setUsername(o.displayName);
                        setUser(e);
                      } else {
                        setUsername('');
                        setUser('');
                      }
                    }}
                    SelectProps={{
                      isClearable: true,
                      msgNoOptionsMatchFilter: 'No options'
                    }}
                    onBlur={validUser}
                  />
                  <ValidationText message={errors.userError} />
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>
                  <RequiredButton />
                </TableCell>
                <TableCell>
                  <ReactSelectMaterialUi
                    required
                    label="チケット種別"
                    className={classes.textField}
                    options={ticketOptions}
                    margin="normal"
                    value={ticketId}
                    onChange={(e, o) => {
                      if ((e === 4 || e === 2) && menuId === 'price') {
                        setMenuId('');
                        setMenuName('');
                      }
                      if (e) {
                        setTicketName(o.label);
                        setTicketId(e);
                      } else {
                        setTicketName('');
                        setTicketId('');
                      }
                    }}
                    SelectProps={{
                      isClearable: true,
                      msgNoOptionsMatchFilter: 'No options'
                    }}
                    onBlur={validTicketId}
                  />
                  <ValidationText message={errors.ticketTypeError} />
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>
                  <RequiredButton />
                </TableCell>
                <TableCell>
                  <ReactSelectMaterialUi
                    required
                    key={`shop-${connectSystem}`}
                    label="店舗名"
                    className={classes.textField}
                    options={shopOptions}
                    margin="normal"
                    value={shopId}
                    onChange={(e, o) => {
                      setMenuName('');
                      setMenuId('');
                      setUsageType(null);
                      setTaxRate(taxRatePercent.TAX_RATE_10_PERCENT);
                      if (e) {
                        setShopName(o.label);
                        setShopId(e);
                      } else {
                        setShopName('');
                        setShopId('');
                      }
                    }}
                    SelectProps={{
                      isClearable: true,
                      msgNoOptionsMatchFilter: 'No options'
                    }}
                    onBlur={validShopId}
                  />
                  <ValidationText message={errors.shopIdError} />
                </TableCell>
              </TableRow>

              {ticketId !== 4 && (
                <TableRow>
                  <TableCell>
                    <RequiredButton />
                  </TableCell>
                  <TableCell>
                    <div className={classes.flexCol}>
                      <ReactSelectMaterialUi
                        required
                        key={`username-${connectSystem}-${shopId}`}
                        label="メニュー名"
                        className={classes.textField}
                        options={
                          allowMenuPrice && ticketId !== 2 && ticketId !== 4
                            ? [
                                {
                                  value: 'price',
                                  label: '金額指定利用メニュー'
                                },
                                ...menuOptions
                              ]
                            : menuOptions
                        }
                        margin="normal"
                        value={menuId}
                        onChange={(e, o) => {
                          if (e) {
                            setMenuName(o.label);
                            setMenuId(e);
                            const menu = menuOptions.find(m => m.value === e);
                            if (menu) {
                              setUsageType(menu.usageType);
                              if (menu.taxType === 'DONATION') {
                                setTaxRate(0);
                              } else if (
                                menu.usageType === USAGE_TYPE_MENU &&
                                menu.reducedTaxType === 'REDUCED'
                              ) {
                                setTaxRate(taxRatePercent.TAX_RATE_8_PERCENT);
                              } else {
                                setTaxRate(taxRatePercent.TAX_RATE_10_PERCENT);
                              }
                            } else {
                              setUsageType(null);
                              setTaxRate(taxRatePercent.TAX_RATE_10_PERCENT);
                            }
                          } else {
                            setMenuName('');
                            setMenuId('');
                            setUsageType(null);
                            setTaxRate(taxRatePercent.TAX_RATE_10_PERCENT);
                          }
                        }}
                        SelectProps={{
                          isClearable: true,
                          msgNoOptionsMatchFilter: 'No options'
                        }}
                        onBlur={validMenuId}
                      />
                      {menuId === 'price' && (
                        <>
                          <TextField
                            type="number"
                            label="利用税込金額"
                            className={classes.textField}
                            margin="normal"
                            onChange={e => {
                              const value =
                                parseInt(
                                  e.target.value.replace(/[^\d]/, ''),
                                  0
                                ) || '';
                              setMenuPrice(value);
                            }}
                            onBlur={() => validateMenuPrice()}
                            value={menuPrice}
                            InputLabelProps={{
                              shrink: true
                            }}
                            inputProps={{
                              min: 1
                            }}
                          />
                          円
                        </>
                      )}
                      {menuId === 'price' && (
                        <div className={classes.textField}>
                          <ValidationText message={errors.menuPriceError} />
                        </div>
                      )}
                    </div>
                    <ValidationText message={errors.menuIdError} />
                  </TableCell>
                </TableRow>
              )}

              {(menuId === 'price' ||
                usageType === USAGE_TYPE_VOUCHER ||
                ticketId === 4) && (
                <TableRow>
                  <TableCell className={classes.colLeft}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    <Typography
                      style={{
                        fontSize: '14px',
                        fontWeight: '400',
                        color: 'rgba(0, 0, 0, 0.54)'
                      }}
                    >
                      消費税区分*
                    </Typography>
                    <RadioGroup
                      row
                      value={taxRate}
                      onChange={e => {
                        setTaxRate(parseFloat(e.target.value));
                      }}
                    >
                      <FormControlLabel
                        value={taxRatePercent.TAX_RATE_10_PERCENT}
                        control={<Radio color="primary" />}
                        label="10%対象"
                      />
                      <FormControlLabel
                        value={taxRatePercent.TAX_RATE_8_PERCENT}
                        control={<Radio color="primary" />}
                        label="8%対象"
                        style={{ marginLeft: 40 }}
                      />
                    </RadioGroup>
                  </TableCell>
                  <TableCell />
                </TableRow>
              )}

              <TableRow>
                <TableCell>
                  <RequiredButton />
                </TableCell>
                <TableCell>
                  <TextField
                    type="number"
                    label="個数"
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      const value =
                        parseInt(e.target.value.replace(/[^\d]/, ''), 0) || '';
                      setUsedTicketNum(value);
                    }}
                    onBlur={() => validateUsedTicketNum()}
                    value={usedTicketNum}
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      min: 1
                    }}
                  />
                  <ValidationText message={errors.usedTicketNumError} />
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <div className={classes.flexCol}>
                    <TextField
                      label="利用日時"
                      type="date"
                      className={classes.textField}
                      margin="normal"
                      onChange={e => {
                        const newVal = moment(e.target.value);
                        const res = usedAt ? moment(usedAt) : moment();
                        res.set({
                          year: newVal.get('year'),
                          date: newVal.get('date'),
                          month: newVal.get('month')
                        });
                        setUsedAt(res.format('YYYY-MM-DDTHH:mm:ss'));
                      }}
                      onBlur={() => validateUsedAt()}
                      value={
                        usedAt ? moment(usedAt).format('YYYY-MM-DD') : null
                      }
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        max: moment().format('YYYY-MM-DD')
                      }}
                    />
                    <TextField
                      type="time"
                      label=" "
                      className={classes.textField}
                      margin="normal"
                      onChange={e => {
                        const newVal = moment(e.target.value, 'HH:mm:ss');
                        const res = usedAt ? moment(usedAt) : moment();
                        res.set({
                          hour: newVal.get('hour'),
                          minute: newVal.get('minute'),
                          second: newVal.get('second')
                        });
                        setUsedAt(res.format('YYYY-MM-DDTHH:mm:ss'));
                      }}
                      onBlur={() => validateUsedAt()}
                      value={usedAt ? moment(usedAt).format('HH:mm:ss') : null}
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        step: 1
                      }}
                    />
                  </div>
                  <ValidationText message={errors.usedAtError} />
                </TableCell>
                <TableCell className={classes.width100} />
              </TableRow>
            </TableBody>
          </Table>
        </Paper>
        <div>
          <CancelButton onClickAction={cancelAction} color="primary" />
          <ConfirmButton onClickAction={confirmAction} />
        </div>

        <Modal open={openAddConfirm}>
          <ShashokuTicketUsedByAdminAddConfirm
            submitData={submitData}
            username={username}
            ticketId={ticketId}
            shopName={shopName}
            menuName={menuName}
            usedTicketNum={usedTicketNum}
            connectSystemName={connectSystemName}
            ticketName={ticketName}
            menuPrice={menuPrice}
            usedAt={usedAt}
            backAction={() => updateOpenAddConfirm(false)}
            registerAction={onSubmitAdd}
            usageType={usageType}
          />
        </Modal>
        <ProgressDialog
          resultMessage={resultMessage}
          openProgress={openAddProgress}
          loading={loading}
          progressOkAction={() => {
            updateOpenAddProgress(false);
            if (resultMessage === 'データの追加が完了しました。') {
              onSuccess();
            }
          }}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
